export default {
  EMAIL: `nuggets.indie@gmail.com`,
};
